import { Plus } from "lucide-react";
import { Btn, Loading, PageHead, Panel, RowTools, SaveBtn, inputCls, move, useSiteDraft } from "@/admin/ui";

export default function Stages() {
  const { draft, patch, save, saving } = useSiteDraft(["stages"]);
  if (!draft) return <Loading />;
  const stages = draft.stages;
  const set = (v) => patch("stages", v);
  return (
    <div className="max-w-2xl">
      <PageHead title="Order flow" desc="Stages each paid order moves through. 'Payment Pending' is used for unpaid orders and 'Processing' once payment arrives. Rename, reorder or add your own stages; single items can be marked 'not processed' inside each order.">
        <SaveBtn save={save} saving={saving} />
      </PageHead>
      <Panel className="space-y-2" data-testid="stages-list">
        {stages.map((s, i) => (
          <div key={s.id || i} className="flex items-center gap-3" data-testid={`stage-row-${i}`}>
            <span className="w-6 text-zinc-400 font-arial text-sm">{i + 1}</span>
            <input value={s.name} onChange={(e) => set(stages.map((x, j) => (j === i ? { ...x, name: e.target.value } : x)))} className={inputCls} data-testid={`stage-name-${i}`} />
            <RowTools i={i} len={stages.length} onMove={(d) => set(move(stages, i, d))}
              onDelete={stages.length > 1 ? () => set(stages.filter((_, j) => j !== i)) : null} testid={`stage-${i}`} />
          </div>
        ))}
        <Btn variant="outline" className="mt-3" onClick={() => set([...stages, { name: "New stage" }])} data-testid="stage-add"><Plus className="w-4 h-4" /> Add stage</Btn>
      </Panel>
    </div>
  );
}
